(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["digitfactory-highlights"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '.digitfactory-highlights';
    const visibleClass = 'is-visible';

    function reveal(section) {
      window.requestAnimationFrame(() => {
        section.classList.add(visibleClass);
      });
    }

    function init(root = document) {
      const sections = root.querySelectorAll(selector);
      if (!sections.length) return;

      const prefersReduced =
        window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      sections.forEach((section) => {
        if (section.dataset.dfhRevealInitialized === 'true') return;
        section.dataset.dfhRevealInitialized = 'true';

        if (prefersReduced || !('IntersectionObserver' in window)) {
          section.classList.add(visibleClass);
          return;
        }

        section.dataset.dfhAnimate = 'true';

        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;

              reveal(section);
              observer.unobserve(section);
            });
          },
          {
            rootMargin: '0px 0px -12% 0px',
            threshold: 0.24,
          }
        );

        observer.observe(section);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => init(), { once: true });
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mothers-day-testimonials"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const sections = document.querySelectorAll('.md-testimonials__cards[data-testimonials-cycle]');

    const prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    sections.forEach(function (section) {
      const dataEl = section.parentElement.querySelector('[data-testimonials-data]');
      if (!dataEl) return;

      let testimonials;
      try {
        testimonials = JSON.parse(dataEl.textContent);
      } catch (e) {
        return;
      }

      const slots = section.querySelectorAll('[data-slot-index]');
      if (!slots.length || testimonials.length <= slots.length) return;

      if (section.dataset.testimonialsCycleInitialized === 'true') return;
      section.dataset.testimonialsCycleInitialized = 'true';

      const interval = parseInt(section.dataset.cycleInterval, 10) || 8000;
      const stagger = parseInt(section.dataset.cycleStagger, 10) || 50;
      const fadeDuration = parseInt(section.dataset.cycleFadeDuration, 10) || 350;

      let cycleIndex = slots.length;

      function updateSlot(slot, data) {
        if (!data) return;

        const quoteEl = slot.querySelector('[data-testimonial-quote]');
        const nameEl = slot.querySelector('[data-testimonial-name]');
        const ratingEl = slot.querySelector('[data-testimonial-rating]');
        const avatarEl = slot.querySelector('[data-testimonial-avatar]');

        if (quoteEl) quoteEl.textContent = data.quote || '';
        if (nameEl) nameEl.textContent = data.name || '';
        if (ratingEl) ratingEl.textContent = data.rating || '';
        if (avatarEl) {
          if (data.avatar) {
            avatarEl.src = data.avatar;
            avatarEl.alt = data.name || '';
            avatarEl.hidden = false;
          } else {
            avatarEl.removeAttribute('src');
            avatarEl.alt = '';
            avatarEl.hidden = true;
          }
        }
      }

      function cycle() {
        const nextSet = [];

        slots.forEach(function (_slot, i) {
          nextSet.push(testimonials[(cycleIndex + i) % testimonials.length]);
        });

        slots.forEach(function (slot, i) {
          setTimeout(function () {
            slot.classList.add('is-fading');
          }, i * stagger);
        });

        setTimeout(
          function () {
            slots.forEach(function (slot, i) {
              updateSlot(slot, nextSet[i]);
            });

            slots.forEach(function (slot, i) {
              setTimeout(function () {
                slot.classList.remove('is-fading');
              }, i * stagger);
            });
          },
          (slots.length - 1) * stagger + fadeDuration
        );

        cycleIndex = (cycleIndex + slots.length) % testimonials.length;
      }

      if (prefersReduced) return;

      let timer = null;

      function startTimer() {
        if (timer) clearInterval(timer);
        timer = setInterval(cycle, interval);
      }

      function stopTimer() {
        if (!timer) return;
        clearInterval(timer);
        timer = null;
      }

      startTimer();

      document.addEventListener('visibilitychange', function () {
        if (document.hidden) {
          stopTimer();
        } else {
          startTimer();
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
